import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { getConsultationOrdoclicUrl } from '../../../data/ordoclic/getConsultationOrdoclicUrl'
import { UserFriendlyError } from '../../../model/Error'
import { ordoclicKeys } from './ordoclic.keys'

interface GetConsultationOrdoclicUrlParams {
  enabled: boolean
}

export const useGetConsultationOrdoclicUrl = ({ enabled }: GetConsultationOrdoclicUrlParams) => {
  const queryKey = useMemo(() => ordoclicKeys.consult(), [])

  const queryResult = useQuery({
    queryKey,
    queryFn: async () => {
      const { data, ok } = await getConsultationOrdoclicUrl()

      if (!data || !ok) {
        throw new UserFriendlyError(
          'error',
          "Une erreur s'est produite",
          "Impossible d'accéder à la vue consultations",
        )
      }
      return data
    },
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    enabled,
  })

  return queryResult
}
